export const AiInsightCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid purple.3',
  CardHeader: {
    flow: 'x', gap: 'Y', align: 'center flex-start',
    SparkleIcon: { extends: 'Icon', icon: 'sparkle', width: 'Z', height: 'Z', color: 'purple' },
    InsightLabel: { text: '{{ aiInsight | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'purple' }
  },
  InsightText: { text: (el, s) => s.insight || '', fontSize: 'Z', color: 'inkText', lineHeight: '1.5' },
  ConfidenceRow: {
    flow: 'x', gap: 'Y', align: 'center flex-start',
    ConfLabel: { text: '{{ confidence | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
    ConfValue: { text: (el, s) => (s.confidence || '95') + '%', fontSize: 'Y', color: 'teal', fontWeight: '600' }
  }
}
